import React, {useEffect, useRef} from 'react';
import {observer} from "mobx-react-lite";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {VideoSlidesArenaContentBox} from "./boxes/video-slides-arena-content.box";
import {Navigation, Virtual} from 'swiper/modules';
import {SwiperSlide} from "swiper/react";
import {VideoSlidesArenaSwiperComponentBox} from "./boxes/video-slides-arena-swiper-component/video-slides-arena-swiper-component.box";
import {SwiperRef} from "swiper/swiper-react";


export const VideoSlidesContentArena: React.FC = observer(() => {
    const services = useServices();
    const swiperRef = useRef<SwiperRef | null>(null)
    const slidesToRender = services.videoSlides.slidesToRender;

    const slideIndex = services.videoSlides.currentSlideIndex;

    useEffect(() => {
        console.log('slide: goto ' + slideIndex);
        swiperRef.current?.swiper.slideTo(slideIndex);
    });

    if(slidesToRender.length === 0) {
        return null;
    }

    return (
       <VideoSlidesArenaContentBox>
            <VideoSlidesArenaSwiperComponentBox modules={[Navigation, Virtual]}
                                                ref={swiperRef}
                slidesPerView={1}
                initialSlide={slideIndex}
                direction={"vertical"}
                onActiveIndexChange={(swiper) => services.videoSlides.currentSlideIndex = swiper.activeIndex}>
                {
                    slidesToRender.map((renderer, index) => {
                        return (
                            <SwiperSlide key={renderer.uniqueKey} virtualIndex={index}>
                                {renderer.render()}
                            </SwiperSlide>
                        )
                    })
                }
            </VideoSlidesArenaSwiperComponentBox>
        </VideoSlidesArenaContentBox>
    );
})